import React, { useEffect } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import 'aos/dist/aos.css';
import AOS from 'aos';
import './About.css';
import Meta from './Meta';

export function About() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true }); 
  }, []);

  return (
      <React.Fragment>
      <Meta
         title="«ИТ Особа» — надежный IT-провайдер для бизнеса и частных лиц в Москве и области"
         description="«ИТ Особа» — современный провайдер связи и IT-услуг с 2008 года. Надежный интернет, видеонаблюдение, телефония и облачные решения для Москвы и области. Реквизиты, лицензии, вакансии и зона покрытия."
       />
    <div className="about-container" data-aos="fade-up">
      <nav className="sidebar" data-aos="fade-right" data-aos-delay="200">
        <NavLink
          to="requisites"
          className={({ isActive }) =>
            isActive ? 'sidebar-link active' : 'sidebar-link'

          }

        >
          Реквизиты
        </NavLink>
        <NavLink
          to="jobs"
          className={({ isActive }) =>
            isActive ? 'sidebar-link active' : 'sidebar-link'
          }
        >
          Вакансии
        </NavLink>
        <NavLink
          to="license"
          className={({ isActive }) =>
            isActive ? 'sidebar-link active' : 'sidebar-link'
          }
        >
          Лицензии
        </NavLink>
        <NavLink
          to="coverage"
          className={({ isActive }) =>
            isActive ? 'sidebar-link active' : 'sidebar-link'
          }
        >
          Карта покрытия
        </NavLink>
      </nav>

      <section className="about-content" data-aos="fade-left" data-aos-delay="400">
        <Outlet />
      </section>
    </div>
    </React.Fragment>
  );
}